import { Component, OnInit, SimpleChanges, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { CarritoHeader } from 'src/app/modal/carrito/carrito-header';
import { LibroDetalle } from 'src/app/modal/catalogo/libro-detalle';
import { SourvenirDetalleResponse } from 'src/app/modal/sourvenir/sourvenir-detalle-response';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { ProtectedImageService } from '../../../app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from '../../../app/modal/catalogo/protected-image-response';
import { ModalHomeComponent } from 'src/app/modal-home/modal-home.component';

@Component({
  selector: 'app-carritocompras',
  templateUrl: './carritocompras.component.html',
  styleUrls: ['./carritocompras.component.scss']
})
export class CarritocomprasComponent implements OnInit, OnDestroy {

  @ViewChild('cartSummary') cartSummary: ElementRef;

  carritoDetalle:CarritoHeader;
  carritoComprasTemp=[];
  carritoCompras=[];
  libroDetalle:LibroDetalle;
  precioTotal:number;
  precio:number;
  isCalculatingTotal: boolean = false;
  monedaCarrito: string = 'S/.'; // Moneda del carrito (S/. o US$)

  // Desglose del resumen de pedido
  resumenPedido: {
    grupos: Array<{
      categoria: string;
      modalidad: string;
      cantidad: number;
      precioUnitario: number;
      subtotal: number;
      descuento: number;
      porcentajeDescuento: string;
    }>;
    subtotalSinDescuento: number;
    totalDescuentos: number;
    totalFinal: number;
  } = {
    grupos: [],
    subtotalSinDescuento: 0,
    totalDescuentos: 0,
    totalFinal: 0
  };

  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private imageUrlCache: Map<string, string | null> = new Map();
  private intervalId: any;
  private imageLoadStartTimes: Map<string, number> = new Map();
  private imageReadyForDisplay: Map<string, boolean> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();
  private isRellenandoCarrito: boolean = false; // Bandera para prevenir llamadas simultáneas

  // Variables para el botón de navegación (desktop)
  showScrollButton: boolean = false;
  isScrolledDown: boolean = false;

  // Variable para estado de carga del botón "Proceder al Pago"
  isProcessingPago: boolean = false;

  // Modal de descuentos por volumen
  modalRefDescuentos: MDBModalRef;

  constructor(private carritoService:CarritoService,
    private novedadesService:NovedadesService, private router:Router,
    private route: ActivatedRoute,
    private usuarioService:UsuarioService,
    private utilitarioService:UtilitarioService,
    private protectedImageService: ProtectedImageService,
    private cdr: ChangeDetectorRef,
    private modalService: MDBModalService){
  }

  async rellenarCarrito(){

    // Prevenir llamadas simultáneas
    if (this.isRellenandoCarrito) {
      return;
    }

    this.isRellenandoCarrito = true;

    // this.utilitarioService.loading=true;
    this.isCalculatingTotal = true;
    this.precioTotal=0;
    this.carritoCompras=[];
    this.carritoComprasTemp=[];
    this.monedaCarrito = 'S/.'; // Reset moneda
    this.clearProtectedImagesCache(); // Limpiar cache de imágenes

    // Forzar detección de cambios para que Angular actualice la vista
    this.cdr.detectChanges();

    // Esperar un mínimo de tiempo para mostrar el skeleton
    const startTime = Date.now();
    const minimumDelay = 1000; // 1 segundo mínimo

    // Estructura temporal para cargar productos
    const productosTemp = [];

    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {

      let libroDetalleTemp = new LibroDetalle();
      let sourvenirDetalleTemp = new SourvenirDetalleResponse();

      if(this.carritoDetalle.lista[i].tipoProducto=="1"){

        // Enviar userId para determinar nacionalidad por tipo de documento
        const userId = this.usuarioService.obtenerIDSessionUsuario();
        libroDetalleTemp = await this.novedadesService.obtenerDetalleLibroAsync(this.carritoDetalle.lista[i].id, userId).toPromise();
        libroDetalleTemp.response.list[0].size = [];

        //console.log(libroDetalleTemp);
        if(Number(libroDetalleTemp.response.list[0].quantity)>10){
          libroDetalleTemp.response.list[0].quantity = "10";
        }

        const itemCarrito = {
          lista:libroDetalleTemp.response.list,
          cantidad:this.carritoDetalle.lista[i].cantidad,
          modalidadId: this.carritoDetalle.lista[i].modalidadId,
          activoId: libroDetalleTemp.response.list[0].activoId,
          categoryId: libroDetalleTemp.response.list[0].categoryId
        };

        this.carritoComprasTemp.push(itemCarrito);

        let modalidadEncontrada = libroDetalleTemp.response.list[0].modalidades.find(data=>
          data.id==this.carritoDetalle.lista[i].modalidadId
        );

        // Si la modalidad no existe (cambió de país), limpiar carrito
        if (!modalidadEncontrada) {
          this.carritoService.limpiarCarrito();
          this.utilitarioService.toastrWarning('Tu carrito fue limpiado porque tu ubicación cambió. Los precios varían según tu país.');
          this.carritoDetalle = null;
          this.carritoCompras = [];
          this.carritoComprasTemp = [];
          return;
        }

        let precio = modalidadEncontrada.price;

        // Determinar moneda del carrito basándose en el primer producto
        if (i === 0 && modalidadEncontrada && modalidadEncontrada.currency) {
          const currency = modalidadEncontrada.currency;
          if (currency === '$' || currency === 'USD' || currency === 'US$' ||
              currency.toLowerCase().includes('dolar') || currency.toLowerCase().includes('dollar')) {
            this.monedaCarrito = 'US$';
          } else {
            this.monedaCarrito = 'S/.';
          }
        }

        // Agregar a estructura temporal para agrupación
        productosTemp.push({
          categoria: this.obtenerCategoria(libroDetalleTemp.response.list[0].categoryName),
          modalidadId: this.carritoDetalle.lista[i].modalidadId,
          cantidad: Number(this.carritoDetalle.lista[i].cantidad),
          precioUnitario: Number(precio)
        });

        // Cargar imagen protegida si tiene activoId
        if (libroDetalleTemp.response.list[0].activoId) {
          this.loadProtectedThumbnail(String(libroDetalleTemp.response.list[0].activoId));
        }

      }
      else if(this.carritoDetalle.lista[i].tipoProducto=="2"){

        sourvenirDetalleTemp = await this.novedadesService.obtenerDetalleSourvenirAsync(this.carritoDetalle.lista[i].id).toPromise();
        // console.log("ingreso");

        if(sourvenirDetalleTemp.response.list[0].size.length>0){
          const result = sourvenirDetalleTemp.response.list[0].size.find( ({ id }) => id ==  this.carritoDetalle.lista[i].sizeID);
          // console.log(result);
          sourvenirDetalleTemp.response.list[0].quantity = result.stock;
          sourvenirDetalleTemp.response.list[0].sizeName  = result.name;
        }

        if(Number(sourvenirDetalleTemp.response.list[0].quantity)>10){
          sourvenirDetalleTemp.response.list[0].quantity = "10";
        }

        const itemCarrito = {
          lista:sourvenirDetalleTemp.response.list,
          cantidad:this.carritoDetalle.lista[i].cantidad,
          modalidadId: this.carritoDetalle.lista[i].modalidadId,
          activoId: sourvenirDetalleTemp.response.list[0].activoId,
          categoryId: sourvenirDetalleTemp.response.list[0].categoryId
        };

        this.carritoComprasTemp.push(itemCarrito);

        // Para souvenirs, usar precio directo sin agrupación de descuentos
        let precioSouvenir = Number(sourvenirDetalleTemp.response.list[0].price);
        productosTemp.push({
          categoria: 'souvenir',
          modalidadId: null,
          cantidad: Number(this.carritoDetalle.lista[i].cantidad),
          precioUnitario: precioSouvenir
        });

        // Cargar imagen protegida si tiene activoId
        if (sourvenirDetalleTemp.response.list[0].activoId) {
          this.loadProtectedThumbnail(String(sourvenirDetalleTemp.response.list[0].activoId));
        }
      }
    }

    // Asignar el array completo UNA SOLA VEZ
    this.carritoCompras = [this.carritoComprasTemp];

    // Calcular total con descuentos por agrupación
    const totalCalculado = this.calcularTotalConDescuentos(productosTemp);

    // Calcular tiempo transcurrido y esperar el mínimo si es necesario
    const elapsedTime = Date.now() - startTime;
    const remainingTime = Math.max(0, minimumDelay - elapsedTime);

    setTimeout(() => {
      // Asignar el total calculado al final
      this.precioTotal = totalCalculado;
      this.isCalculatingTotal = false;
      this.isRellenandoCarrito = false; // Liberar bandera
      this.cdr.detectChanges(); // Forzar detección de cambios
    }, remainingTime);

    // this.utilitarioService.loading=false;

  }
  
  obtenerPrecio(id,xd){
    const modalidad = id.modalidades.find(data => data.id == xd);
    if (!modalidad) {
      // Si la modalidad no existe (cambió de país), usar la primera disponible
      return id.modalidades.length > 0 ? id.modalidades[0].price : 0;
    }
    return modalidad.price;
  }
  obtenerModalidad(id,xd){
    const modalidad = id.modalidades.find(data => data.id == xd);
    if (!modalidad) return '';

    // Mapear abreviatura a descripción completa
    const nombreCompleto = {
      'N': 'Particular Nacional',
      'CN': 'Comercial Nacional',
      'CE': 'Comercial Extranjero'
    };

    return nombreCompleto[modalidad.name] || modalidad.name;
  }

  /**
   * Obtiene la moneda de la modalidad seleccionada.
   * Formatea "S/." para soles y "US$" para dólares.
   */
  obtenerMoneda(id, modalidadId): string {
    const modalidad = id.modalidades.find(data => data.id == modalidadId);
    if (!modalidad || !modalidad.currency) {
      return 'S/.'; // Default soles
    }

    const currency = modalidad.currency;
    // Si es dólares, formatear como US$
    if (currency === '$' || currency === 'USD' || currency === 'US$' ||
        currency.toLowerCase().includes('dolar') || currency.toLowerCase().includes('dollar')) {
      return 'US$';
    }
    // Si es soles
    return 'S/.';
  }

  obtenerExiteSession(){
    return this.usuarioService.existeSesionUsuario();
  }

  async procesarPago(){

    if(this.obtenerExiteSession()){
      // Activar estado de carga
      this.isProcessingPago = true;

      try {
        let carritoDetalleTemp = new CarritoHeader();
        carritoDetalleTemp=this.carritoService.obtenerCarritoCompras()
        // console.log(carritoDetalleTemp);
        for (let i = 0; i < carritoDetalleTemp.lista.length; i++) {

          let libroDetalleTemp = new LibroDetalle();
          let libroSourvenirTemp=new SourvenirDetalleResponse();
          let stockdisponible:number;

          if(this.carritoDetalle.lista[i].tipoProducto=="1"){

            // Enviar userId para determinar nacionalidad por tipo de documento
            const userIdValidacion = this.usuarioService.obtenerIDSessionUsuario();
            libroDetalleTemp = await this.novedadesService.obtenerDetalleLibroAsync(this.carritoDetalle.lista[i].id, userIdValidacion).toPromise();
            // console.log("libroDetalleTemp",libroDetalleTemp);

            stockdisponible = Number(libroDetalleTemp.response.list[0].quantity) - Number(this.carritoDetalle.lista[i].cantidad);

            if(stockdisponible<0){
              this.utilitarioService.toastrInfo("No hay stock disponible en el libro " + libroDetalleTemp.response.list[0].title + ", cantidad disponible: " + libroDetalleTemp.response.list[0].quantity);
              this.isProcessingPago = false;
              return false;
            }

          }else if(this.carritoDetalle.lista[i].tipoProducto=="2"){

              libroSourvenirTemp = await this.novedadesService.obtenerDetalleSourvenirAsync(this.carritoDetalle.lista[i].id).toPromise();
              // console.log("libroSourvenirTemp",libroSourvenirTemp);

              if(libroSourvenirTemp.response.list[0].size.length>0){
                const result = libroSourvenirTemp.response.list[0].size.find( ({ id }) => id ==  this.carritoDetalle.lista[i].sizeID);
                libroSourvenirTemp.response.list[0].quantity = result.stock;
              }

              stockdisponible = Number(libroSourvenirTemp.response.list[0].quantity) - Number(this.carritoDetalle.lista[i].cantidad);

              if(stockdisponible<0){
                this.utilitarioService.toastrInfo("No hay stock disponible en el producto " + libroSourvenirTemp.response.list[0].title + ", cantidad disponible: " + libroSourvenirTemp.response.list[0].quantity);
                this.isProcessingPago = false;
                return;
              }

          }


        }
        // Desactivar estado de carga antes de navegar
        this.isProcessingPago = false;
        this.router.navigate(['/procesarpago']);
      } catch (error) {
        console.error('Error al procesar pago:', error);
        this.utilitarioService.toastrWarning("Error al validar el carrito. Intente nuevamente.");
        this.isProcessingPago = false;
      }
    }
    else{
      this.utilitarioService.toastrWarning("Necesita iniciar sesión");
    }
  }

  obtenerCarrito(){
    this.carritoDetalle = new CarritoHeader();
    this.carritoDetalle=this.carritoService.obtenerCarritoCompras()
    this.rellenarCarrito();
  }

  limpiarCarrito(){
    // this.rellenarCarrito();
    this.carritoService.limpiarCarrito();
    this.carritoCompras = [];
    this.carritoComprasTemp = [];
    this.precioTotal = 0;
    this.clearProtectedImagesCache();
  }

  fprecioTotal(){
    this.precio = this.precioTotal
    return this.precio
  }
  ngOnInit(): void {
   //verifica si exite libros agregados
   this.carritoService.verificarCarritoSelecionados();
   this.obtenerCarrito();

   // Inicializar cantidad anterior
   this.cantidadAnterior = this.carritoService.cantidadCarrito;

   // Verificar cambios en el carrito cada segundo
   this.intervalId = setInterval(() => {
     this.verificarCambiosCarrito();
   }, 1000);

   // Agregar listener para detectar scroll (solo desktop)
   window.addEventListener('scroll', this.onWindowScroll.bind(this));

   // Verificar si viene de un timeout de pago Niubiz
   this.route.queryParams.subscribe(params => {
     if (params['estado'] === 'timeout') {
       this.utilitarioService.toastrWarning(
         'El tiempo de la sesión de pago ha expirado. Por favor, intente nuevamente.',
         'Sesión expirada'
       );
       // Limpiar el parámetro de la URL sin recargar la página
       this.router.navigate(['/carrito'], {
         queryParams: {},
         replaceUrl: true
       });
     }
   });

   // Mostrar popup de descuentos por volumen
   if (localStorage.getItem('hideDiscountModal') !== 'true' &&
       sessionStorage.getItem('discountModalShownInFlow') !== 'true') {
     setTimeout(() => {
       this.modalRefDescuentos = this.modalService.show(
         ModalHomeComponent,
         {
           backdrop: true,
           keyboard: true,
           focus: true,
           show: false,
           ignoreBackdropClick: false,
           class: 'modal-dialog modal-dialog-centered modal-lg',
           containerClass: 'top',
           animated: true,
           data: {}
         }
       );
     }, 500);
   }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    // Remover listener de scroll
    window.removeEventListener('scroll', this.onWindowScroll.bind(this));
    // Cerrar el modal de descuentos si está abierto
    if (this.modalRefDescuentos) {
      this.modalRefDescuentos.hide();
    }
  }

  private cantidadAnterior: number = 0;

  verificarCambiosCarrito(): void {
    const cantidadActual = this.carritoService.cantidadCarrito;
    if (cantidadActual !== this.cantidadAnterior) {
      this.obtenerCarrito();
      this.cantidadAnterior = cantidadActual;
    }
  }

  frecalculartotal(fila:number,cantidad:number,stock:string){
    //console.log(cantidad);
    //console.log(stock);
    
    if (cantidad>10){
      //console.log("por defecto");
      this.carritoDetalle.lista[fila].cantidad = stock;
      this.utilitarioService.toastrInfo("cantidad maxíma : " + "10");
    }else{
      //console.log("stock");
      if (cantidad > Number(stock)){
        this.utilitarioService.toastrInfo("queda en stock : " + stock + " cantidades");
        this.carritoDetalle.lista[fila].cantidad = stock;
      }      
    }

    if (cantidad<1){
      this.carritoDetalle.lista[fila].cantidad = "1";
    }
  
    //actualiza storage con nuevos cantidades    
    this.carritoService.actualizarCarrito(this.carritoDetalle.lista);
    this.rellenarCarrito();
    
  }

  // feliminarCarrito(i: number){

  //   this.carritoDetalle.lista.splice(i, 1);
  //   this.carritoService.actualizarCarrito(this.carritoDetalle.lista);
  //   this.rellenarCarrito();

  // }
  imagen(img:String){
   
    return img.replace(/_=2?/,"");
  }
  feliminarCarrito(i: number){
    // Eliminar del carritoDetalle
    this.carritoDetalle.lista.splice(i, 1);

    // Actualizar en el servicio primero
    this.carritoService.eliminarCarrito(this.carritoDetalle.lista);

    // Limpiar completamente los arrays visuales (como en un F5)
    this.carritoComprasTemp = [];
    this.carritoCompras = [];
    this.precioTotal = 0;

    // Limpiar cache de imágenes
    this.clearProtectedImagesCache();

    // Activar estado de cálculo para mostrar skeletons
    this.isCalculatingTotal = true;

    // Forzar detección de cambios para que Angular actualice la vista
    this.cdr.detectChanges();

    // Recargar carrito completo desde cero
    this.rellenarCarrito();
  }

  // ---------- Métodos para imágenes protegidas ----------
  loadProtectedThumbnail(imageId: string): void {
    if (!imageId) {
      return;
    }

    // Evitar múltiples peticiones para la misma imagen
    if (this.protectedImages.has(imageId)) {
      return; // Ya está siendo procesada o ya existe
    }

    // Marcar como en proceso para evitar duplicados
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now()
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        // Actualizar cache de URL
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);

        // Calcular tiempo transcurrido desde que inició la carga
        const startTime = this.imageLoadStartTimes.get(imageId) || Date.now();
        const elapsedTime = Date.now() - startTime;
        const minimumDelay = 800; // 800ms mínimo para apreciar el skeleton

        // Siempre esperar el tiempo mínimo completo
        const timeToWait = Math.max(0, minimumDelay - elapsedTime);

        setTimeout(() => {
          this.isSkeletonVisible.set(imageId, false);
          this.imageReadyForDisplay.set(imageId, true);
          this.cdr.detectChanges();
        }, timeToWait);
      },
      error: (error) => {
        console.error('Error cargando imagen protegida:', imageId, error);
        // Remover de la lista en caso de error para permitir reintento
        this.protectedImages.delete(imageId);
        this.cdr.detectChanges();
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    if (!imageId) {
      return null;
    }

    // Inicializar skeleton como visible y comenzar carga si es la primera vez
    if (!this.imageLoadStartTimes.has(imageId)) {
      this.imageLoadStartTimes.set(imageId, Date.now());
      this.isSkeletonVisible.set(imageId, true);
      this.loadProtectedThumbnail(imageId);
      return null;
    }

    // Si el skeleton está visible, no mostrar imagen aún
    if (this.isSkeletonVisible.get(imageId)) {
      return null;
    }

    // Si ya no está el skeleton, devolver la URL desde el cache
    return this.imageUrlCache.get(imageId) || null;
  }

  // Método público para el template
  shouldShowSkeleton(imageId: string): boolean {
    if (!imageId) return false;

    // Si nunca se ha iniciado la carga, solo marcar como visible
    // La carga ya se hace en rellenarCarrito()
    if (!this.imageLoadStartTimes.has(imageId)) {
      this.imageLoadStartTimes.set(imageId, Date.now());
      this.isSkeletonVisible.set(imageId, true);
      return true;
    }

    return this.isSkeletonVisible.get(imageId) || false;
  }

  clearProtectedImagesCache(): void {
    this.protectedImages.clear();
    this.imageUrlCache.clear();
    this.imageLoadStartTimes.clear();
    this.imageReadyForDisplay.clear();
    this.isSkeletonVisible.clear();
  }

  // Método auxiliar para forzar carga desde template
  ensureImageLoaded(imageId: string): void {
    if (imageId && !this.protectedImages.has(imageId)) {
      this.loadProtectedThumbnail(imageId);
    }
  }

  // Método para determinar si es portada (no necesita calcular dimensiones)
  isPortada(item: any): boolean {
    // Verificar primero en el nivel superior del objeto (más rápido)
    if (item?.categoryId === '2') {
      return true;
    }
    // Fallback: verificar en lista[0] si no está en el nivel superior
    return item?.lista?.[0]?.categoryId === '2';
  }

  // Método para calcular dimensiones del skeleton basado en orientación (solo para fotografías)
  getSkeletonDimensions(item: any): { width: string; height: string } {
    if (!item || !item.lista || !item.lista[0]) {
      // Valores por defecto si no hay datos
      return { width: '160px', height: '160px' };
    }

    const producto = item.lista[0];

    // Fotografías: calcular según orientación
    const imageWidth = parseInt(producto.width) || 160;
    const imageHeight = parseInt(producto.height) || 160;

    // Determinar orientación
    const isVertical = imageHeight > imageWidth;

    if (isVertical) {
      // Para imágenes verticales: ancho menor, alto mayor
      return { width: '120px', height: '160px' };
    } else {
      // Para imágenes horizontales: ancho mayor, alto menor
      return { width: '160px', height: '120px' };
    }
  }

  // ========== MÉTODOS PARA CÁLCULO DE DESCUENTOS POR AGRUPACIÓN ==========

  /**
   * Identifica la categoría del producto
   */
  obtenerCategoria(categoryName: string): string {
    if (!categoryName) return 'otro';

    const catUpper = categoryName.toUpperCase();
    if (catUpper.includes('FOTOGRAFIA')) return 'fotografia';
    if (catUpper.includes('PORTADA')) return 'portada';
    return 'otro';
  }

  /**
   * Agrupa productos por categoría y modalidad, y calcula el total con descuentos
   */
  calcularTotalConDescuentos(productos: any[]): number {
    // Limpiar resumen anterior
    this.resumenPedido = {
      grupos: [],
      subtotalSinDescuento: 0,
      totalDescuentos: 0,
      totalFinal: 0
    };

    // Estructura para agrupar: Map<"categoria-modalidadId", {cantidad, precioUnitario}>
    const grupos = new Map<string, {totalUnidades: number, precioUnitario: number, categoria: string, modalidadId: string}>();

    // 1. Agrupar productos por categoría + modalidad
    productos.forEach(prod => {
      // Souvenirs no se agrupan para descuentos
      if (prod.categoria === 'souvenir') {
        const key = `souvenir-${Math.random()}`; // Clave única para cada souvenir
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: 'souvenir',
          modalidadId: null
        });
        return;
      }

      // Para fotografías y portadas: agrupar por categoria-modalidad
      const key = `${prod.categoria}-${prod.modalidadId}`;

      if (grupos.has(key)) {
        const grupo = grupos.get(key);
        grupo.totalUnidades += prod.cantidad;
      } else {
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: prod.categoria,
          modalidadId: prod.modalidadId
        });
      }
    });

    // 2. Calcular total aplicando descuentos por grupo
    let totalGeneral = 0;
    let subtotalSinDescuento = 0;
    let totalDescuentos = 0;

    grupos.forEach((grupo, key) => {
      const { totalUnidades, precioUnitario, categoria, modalidadId } = grupo;

      // Calcular subtotal sin descuento
      const subtotalOriginal = totalUnidades * precioUnitario;
      subtotalSinDescuento += subtotalOriginal;

      // Si es souvenir, calcular sin descuentos
      if (key.startsWith('souvenir-')) {
        totalGeneral += totalUnidades * precioUnitario;

        this.resumenPedido.grupos.push({
          categoria: 'Souvenir',
          modalidad: 'N/A',
          cantidad: totalUnidades,
          precioUnitario: precioUnitario,
          subtotal: totalUnidades * precioUnitario,
          descuento: 0,
          porcentajeDescuento: '0%'
        });
        return;
      }

      // Aplicar reglas de descuento según cantidad
      let subtotal = 0;
      let descuento = 0;
      let porcentajeDescuento = '0%';

      if (totalUnidades >= 1 && totalUnidades <= 4) {
        // Sin descuento
        subtotal = totalUnidades * precioUnitario;
        descuento = 0;
        porcentajeDescuento = '0%';

      } else if (totalUnidades === 5) {
        // Pack de 5: pagas 4, llevas 5 (20% descuento efectivo)
        subtotal = 4 * precioUnitario;
        descuento = precioUnitario; // Te ahorras 1 unidad
        porcentajeDescuento = '20%';

      } else if (totalUnidades >= 6 && totalUnidades <= 24) {
        // 20% de descuento
        const precioConDescuento = precioUnitario * 0.8;
        subtotal = totalUnidades * precioConDescuento;
        descuento = subtotalOriginal - subtotal;
        porcentajeDescuento = '20%';

      } else if (totalUnidades >= 25) {
        // 28% de descuento total (20% + 10% adicional)
        const precioConPrimerDescuento = precioUnitario * 0.8;
        const precioFinal = precioConPrimerDescuento * 0.9;
        subtotal = totalUnidades * precioFinal;
        descuento = subtotalOriginal - subtotal;
        porcentajeDescuento = '20% + 10% adicional';
      }

      totalGeneral += subtotal;
      totalDescuentos += descuento;

      // Obtener nombre de categoría y modalidad
      const categoriaNombre = this.obtenerNombreCategoria(categoria);
      const modalidadNombre = this.obtenerNombreModalidad(modalidadId);

      // Agregar al desglose
      this.resumenPedido.grupos.push({
        categoria: categoriaNombre,
        modalidad: modalidadNombre,
        cantidad: totalUnidades,
        precioUnitario: precioUnitario,
        subtotal: subtotal,
        descuento: descuento,
        porcentajeDescuento: porcentajeDescuento
      });
    });

    // Actualizar resumen
    this.resumenPedido.subtotalSinDescuento = Number(subtotalSinDescuento.toFixed(2));
    this.resumenPedido.totalDescuentos = Number(totalDescuentos.toFixed(2));
    this.resumenPedido.totalFinal = Number(totalGeneral.toFixed(2));

    return Number(totalGeneral.toFixed(2));
  }

  /**
   * Obtiene el nombre legible de la categoría
   */
  obtenerNombreCategoria(categoria: string): string {
    const nombres = {
      'fotografia': 'Fotografías',
      'portada': 'Páginas Históricas',
      'souvenir': 'Souvenirs',
      'otro': 'Otros'
    };
    return nombres[categoria] || categoria;
  }

  /**
   * Obtiene el nombre legible de la modalidad
   */
  obtenerNombreModalidad(modalidadId: string): string {
    if (!modalidadId) return 'N/A';

    const nombres = {
      '1': 'Particular Nacional (N)',
      '2': 'Comercial Nacional (CN)',
      '3': 'Comercial Extranjero (CE)'
    };
    return nombres[modalidadId] || `Modalidad ${modalidadId}`;
  }

  /**
   * Hace scroll suave hasta la sección del resumen (solo mobile)
   */
  scrollToSummary(): void {
    if (this.cartSummary && this.cartSummary.nativeElement) {
      this.cartSummary.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  /**
   * Obtiene los datos cargados de un producto del carrito
   */
  getProductoData(index: number): any {
    return this.carritoCompras[0]?.[index];
  }

  /**
   * Detecta el scroll de la página para mostrar/ocultar el botón de navegación
   */
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Mostrar botón solo si hay suficiente contenido para hacer scroll
    this.showScrollButton = documentHeight > windowHeight * 1.5;

    // Determinar si el usuario está en la mitad inferior de la página
    const scrollThreshold = (documentHeight - windowHeight) / 2;
    this.isScrolledDown = scrollPosition > scrollThreshold;
  }

  /**
   * Alterna entre scroll arriba y scroll abajo
   */
  toggleScroll(): void {
    if (this.isScrolledDown) {
      // Scroll hacia arriba
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Scroll hacia abajo (al final de la página)
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    }
  }

  /**
   * Scroll hacia arriba (para el botón del footer)
   */
  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

}
